import { useApiPostQuery } from '../useApi'

export const useLecturesList = (level?: string) => {
  const requestBody = level ? { LEVEL: level } : {}

  return useApiPostQuery<any>(
    '/lectures/list',
    ['lecture-list', level],
    requestBody,
    true
  )
}
